<template>
  <div>
    <div v-if="showPage">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import './constant'
import { mapGetters } from 'vuex'
// import store from '@/store/index'
export default {
  data() {
    return {
      inited: false
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userAuth/getUsersCurrentInfo'
    }),
    showPage() {
      // const auth_type = global.APP_CONFIG.auth_type
      const flag = true || this.userInfo
      return flag
    }
  },
  watch: {
    async $route(_to, _from) {
      if (!this.inited) {
        await this.init()
      }
    }
  },
  async created() {
    await this.init()
  },
  methods: {
    async init() {
      this.inited = true
    }
  }
}
</script>

<style lang="less" scoped></style>
